var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 39,
    height: 39,
    fill: "#E2DEFF",
    stroke: "#4A03A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 7,
    height: 7,
    fill: "#4A03A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1004 17.94C31.1004 18.48 30.8104 18.97 30.3504 19.22L28.6104 20.16L27.1304 20.95L24.0604 22.61C23.7304 22.79 23.3704 22.88 23.0004 22.88C22.6304 22.88 22.2704 22.79 21.9404 22.61L15.6504 19.22C15.1904 18.97 14.9004 18.48 14.9004 17.94C14.9004 17.4 15.1904 16.91 15.6504 16.66L17.6204 15.6L19.1904 14.75L21.9404 13.27C22.6004 12.91 23.4004 12.91 24.0604 13.27L30.3504 16.66C30.8104 16.91 31.1004 17.4 31.1004 17.94Z",
    fill: "#4A03A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9007 23.7901L15.0507 20.8701C14.6007 20.6401 14.0807 20.6701 13.6507 20.9301C13.2207 21.1901 12.9707 21.6501 12.9707 22.1501V27.6801C12.9707 28.6401 13.5007 29.5001 14.3607 29.9301L20.2107 32.8501C20.4107 32.9501 20.6307 33.0001 20.8507 33.0001C21.1107 33.0001 21.3707 32.9301 21.6007 32.7801C22.0307 32.5201 22.2807 32.0601 22.2807 31.5601V26.0301C22.2907 25.0801 21.7607 24.2201 20.9007 23.7901Z",
    fill: "#4A03A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0309 22.1496V27.6796C33.0309 28.6296 32.5009 29.4896 31.6409 29.9196L25.7909 32.8496C25.5909 32.9496 25.3709 32.9996 25.1509 32.9996C24.8909 32.9996 24.6309 32.9296 24.3909 32.7796C23.9709 32.5196 23.7109 32.0596 23.7109 31.5596V26.0396C23.7109 25.0796 24.2409 24.2196 25.1009 23.7896L27.2509 22.7196L28.7509 21.9696L30.9509 20.8696C31.4009 20.6396 31.9209 20.6596 32.3509 20.9296C32.7709 21.1896 33.0309 21.6496 33.0309 22.1496Z",
    fill: "#4A03A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6091 20.16L27.1291 20.95L17.6191 15.6L19.1891 14.75L28.3691 19.93C28.4691 19.99 28.5491 20.07 28.6091 20.16Z",
    fill: "#4A03A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 21.9707V24.2407C28.75 24.6507 28.41 24.9907 28 24.9907C27.59 24.9907 27.25 24.6507 27.25 24.2407V22.7207L28.75 21.9707Z",
    fill: "#4A03A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCard2);
export default __webpack_public_path__ + "static/media/benefit-card-2.aff6fd40b8b84e8cab1409ed70a7f40b.svg";
export { ForwardRef as ReactComponent };